import script from "./StoreView.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreView.vue?vue&type=script&setup=true&lang=js"

import "./StoreView.vue?vue&type=style&index=0&id=24144433&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24144433"]])

export default __exports__